import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";

const INSIGHTS = [
  "Next Best Action ready",
  "12 accounts to chase today",
  "₹18.4L recoverable this week",
  "2 settlements awaiting approval",
];

// Slim "intelligence" ribbon under the nav. Presentational only — no data, no CTAs.
export const AiRibbon = () => {
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const id = setInterval(() => {
      setVisible(false);
      setTimeout(() => { setIdx((i) => (i + 1) % INSIGHTS.length); setVisible(true); }, 450);
    }, 3600);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      className="hidden sm:flex items-center justify-center gap-4 border-b border-slate-200/70 bg-[#0B3D91]/[0.04] px-6 py-2 text-[13px] backdrop-blur-md"
      data-testid="intelligence-ribbon"
    >
      <span className="flex items-center gap-1.5 font-semibold text-slate-600">
        <span className="h-1.5 w-1.5 rounded-full bg-[#16A34A] ros-live-dot" />
        Portfolio Health: <b className="text-slate-900">Good</b>
      </span>
      <span className="h-3.5 w-px bg-slate-200" />
      <span className="font-semibold text-slate-600"><b className="text-slate-900">₹12.4 Cr</b> Outstanding</span>
      <span className="hidden lg:inline h-3.5 w-px bg-slate-200" />
      <span className="hidden lg:inline font-semibold text-slate-600"><b className="text-slate-900">42</b> Payments Today</span>
      <span className="hidden lg:inline h-3.5 w-px bg-slate-200" />
      <span className="hidden lg:inline font-semibold text-slate-600">Recovery Health Score <b className="text-slate-900">82</b></span>
      <span className="h-3.5 w-px bg-slate-200" />
      <span className="inline-flex min-w-[220px] items-center gap-2 font-bold text-[#0B3D91]">
        <Sparkles className="h-3.5 w-3.5 text-[#0ea5a4]" />
        <span className={`ros-fade ${visible ? "opacity-100" : "opacity-0"}`}>{INSIGHTS[idx]}</span>
      </span>
    </div>
  );
};
